module["exports"] = [
  "Ireland"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_IE/address/default_country.js
 ** module id = 521
 ** module chunks = 0
 **/